import React, { useEffect, useRef, useState } from "react";
import vAdminformat from "../../adminFormat";


import config from '../../config';
import axios from "axios";
import { headers } from "../../token";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const server_backend = config.API_URL;

const ManualInvoiceCreate = ({ email, isOrder }) => {

    const [loading, setLoading] = useState(false);
    const [modalItem, setModalItem] = useState(false);
    const [modalProduts, setModalProduct] = useState(false);
    const [ProductList, setProductList] = useState([]);
    const [attachOrder, setAttachOrder] = useState(isOrder && true);
    const [OrderList, setOrderList] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [temporaryOrder, setTemporaryOrder] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [statusQuot, setStatusQuot] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [ammountSummary, setAmmountSummary] = useState([]);

    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");
    const [CustomerList, setCustomerList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerViews, setCustomerView] = useState(!isOrder && true);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: "2021-01-01",
        to: new Date().toISOString().split("T")[0], // Current date as default

    });

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        quot_ID: null,
        cust_ID: null,
        name: "",
        lastname: "",
        fullname: "",
        email: "",
        phone: "",
        phone2: "",
        address: "",
        city: "",
        zipcode: "",
        country: "",
        shipping_address: "",
        shipping_city: "",
        shipping_zipcode: "",
        shipping_country: "",
        contact_fullname: "",
        contact_phone: "",
        contact_email: "",
        comment: "",
        date_created: null,
        user_created: "",
        date_modify: null,
        user_modify: null,
        date_deleted: null,
        user_deleted: null,
        est_ID: null,
        status_name: "",
        qrcode: "",
        address_choose: 0,
        date_close: null,
        user_close: null,
        comment_close: null,
        subtotal_summary: 0,
        taxtotal_summary: 0,
        total_summary: 0,
        discount_summary: "0.0000",
        items: [],
        product_item: '',
        product_name: '',
        product_price: '',
        product_qty: '',
        product_discount: ''
    });

    const clearForm = () => {
        setFormData({
            quot_ID: null,
            cust_ID: null,
            name: "",
            lastname: "",
            fullname: "",
            email: "",
            phone: "",
            phone2: "",
            address: "",
            city: "",
            zipcode: "",
            country: "",
            shipping_address: "",
            shipping_city: "",
            shipping_zipcode: "",
            shipping_country: "",
            contact_fullname: "",
            contact_phone: "",
            contact_email: "",
            comment: "",
            date_created: null,
            user_created: "",
            date_modify: null,
            user_modify: null,
            date_deleted: null,
            user_deleted: null,
            est_ID: null,
            status_name: "",
            qrcode: "",
            address_choose: 0,
            date_close: null,
            user_close: null,
            comment_close: null,
            subtotal_summary: 0,
            taxtotal_summary: 0,
            total_summary: 0,
            discount_summary: "0.0000",
            items: [],
            product_item: '',
            product_name: '',
            product_price: '',
            product_qty: '',
            product_discount: ''
        })
    }

    const showModalItem = () => {
        setModalItem(true)
    }

    const closeModalItem = () => {
        setCurrentItem("");
        setModalItem(false);
        setEditMode(false);
    }

    useEffect(() => {
        const getProduct = async () => {
            try {
                const response = await axios.get(`${server_backend}/Products/list`, headers);
                //console.log("Unexpected error, please check")

                if (response.data.RES_CODE === "00") {
                    setProductList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getProduct();
    }, []);

    const showModalAttOrder = () => {
        setAttachOrder(true)
    }

    const closeModalAttOrder = () => {

        if (temporaryOrder) {
            setAttachOrder(false)
        } else {
            Swal.fire({
                icon: 'error',
                title: "You must select an order to proceed with generating the invoice.",
                showConfirmButton: false,
                timer: 2000
            });
        }

    }

    useEffect(() => {
        if (isOrder) {
            FilterOrder(); 
        } else {
            FilterCustomer()
        }

    }, [filterBy, filterStatus, filterValue]);

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterOrder(value);
    };

    const handleCustFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
        FilterCustomer();
    };
    const FilterOrder = async () => {
        console.log("Unexpected error, please check")
        try {
            const response = await axios.get(`${server_backend}/Orders/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);
            setOrderList(response.data.RES_RESULT);
            console.log("Unexpected error, please check")
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    const FilterCustomer = async () => {
        //console.log("Unexpected error, please check")

        try {
            const response = await axios.get(`${server_backend}/customers/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setCustomerList(response.data.RES_RESULT);
            //console.log("Unexpected error, please check")

        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };



    const handleCustFilterValueChange = (e) => {
        setFilterValue(e.target.value);
        FilterCustomer(e.target.value);
        setShowDropdown(true);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const confirmOrderSelect = async () => {

        if (temporaryOrder) {
            try {
                const response = await axios.get(`${server_backend}/Orders/select?id=${temporaryOrder}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    console.log("Unexpected error, please check")
                    
                    setSelectedOrder(data);
                    setFormData({ ...data, items: [] });
                    setSelectedOption('yes');

                    for (let items of data.jobs_manual) {
                        const OrderItem = {
                            job_ID: items.job_ID, 
                            ordj_name: items.job_number,  
                            ordj_qty: items.qty,
                            ordj_price: items.price,
                            ordj_discount: items.discount,
                            ordj_total: items.total,
                            products: [] 
                        };

                    
                        setFormData((prevFormData) => {
                            let updatedItems = [...prevFormData.items, OrderItem];
                            updatedItems = ensureOthersAtEnd(updatedItems); 
                            return { ...prevFormData, items: updatedItems };
                        });
                    }

                    closeModalAttOrder(); 
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: "You must select an order to proceed with generating the invoice.",
                showConfirmButton: false,
                timer: 2000
            });
        }
    };


    const handleOrderSelect = (Order) => {
        setTemporaryOrder(Order);
    };

    const handleCustomerSelect = (customer) => {

        setSelectedCustomer(customer);
    };

    const confirmCustomer = async () => {

        if (selectedCustomer) {
            try {
                const response = await axios.get(`${server_backend}/customers/select?id=${selectedCustomer}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    //console.log("Unexpected error, please check")

                    setFormData({
                        quot_ID: null,
                        cust_ID: data.cust_ID,
                        name: data.name,
                        lastname: data.lastname,
                        fullname: data.fullname,
                        email: data.email,
                        phone: data.phone,
                        phone2: data.phone2,
                        address: data.address,
                        city: data.city,
                        zipcode: data.zipcode,
                        country: data.country,
                        shipping_address: data.shipping_address,
                        shipping_city: data.shipping_city,
                        shipping_zipcode: data.shipping_zipcode,
                        shipping_country: data.shipping_country,
                        contact_fullname: data.contact_fullname,
                        contact_phone: data.contact_phone,
                        contact_email: data.contact_email,
                        comment: data.comment,
                        date_created: null,
                        user_created: "",
                        date_modify: null,
                        user_modify: null,
                        date_deleted: null,
                        user_deleted: null,
                        est_ID: null,
                        status_name: "",
                        qrcode: "",
                        address_choose: 0,
                        date_close: null,
                        user_close: null,
                        comment_close: null,
                        subtotal_summary: 0,
                        taxtotal_summary: 0,
                        total_summary: 0,
                        discount_summary: "0.0000",
                        items: [],
                        product_item: '',
                        product_name: '',
                        product_price: '',
                        product_qty: '',
                        product_discount: ''
                    });

                    closeModalCustomerViews();
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: "You must select a customer to proceed with generating the invoice.",
                showConfirmButton: false,
                timer: 2000
            });
        }

    }

    useEffect(() => {
        const getStatusOrder = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/invoice`, headers);

                if (response.data.RES_CODE === "00") {
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getStatusOrder();
    }, []);

    function confirmNoOrderSelection() {
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "are you sure you don't want to add this to an order? Any data already entered in the invoice will be cleared.",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setSelectedOption('no');
                clearForm();
            }
        });
    }


    const [selectedProducts, setSelectedProducts] = useState([]);
    const [currentItem, setCurrentItem] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [editIndex, setEditIndex] = useState(null);


    const handleCheckboxChange = (product) => {
        setSelectedProducts((prevSelected) => {
            if (prevSelected.some((p) => p.pto_ID === product.pto_ID)) {
                return prevSelected.filter((p) => p.pto_ID !== product.pto_ID);
            } else {

                return [...prevSelected, product];
            }
        });
    };

    const ensureOthersAtEnd = (items) => {
        let othersIndex = items.findIndex(item => item.ordj_name === "Others");
        if (othersIndex !== -1) {
            const othersItem = items.splice(othersIndex, 1)[0];
            return [...items, othersItem]; // We move it at the end

        }
        return items;
    };

    const handleSaveChanges = () => {
        /*   if (selectedProducts.length === 0) {
              alert("Please select at least one product.");
              return;
          } */

        let newItem;
        if (!currentItem) {

            const othersItem = formData.items.find(item => item.ordj_name === "Others");
            if (othersItem) {

                othersItem.products.push(...selectedProducts.map(product => ({
                    pto_ID: product.pto_ID,
                    qty: 1,
                    name: product.ordj_name,
                    price: product.price,
                    comment: product.comment || null,
                    discount: product.discount || "0.0000"
                })));
                newItem = othersItem;
            } else {

                newItem = {
                    job_ID: 0, 
                    ordj_name: "Others",  
                    products: selectedProducts.map((product) => ({
                        pto_ID: product.pto_ID,
                        qty: 1,
                        name: product.ordj_name,
                        price: product.price,
                        comment: product.comment || null,
                        discount: product.discount || "0.0000"
                    }))
                };
            }
        } else {
    
            newItem = {
                job_ID: currentItem.job_ID ? currentItem.job_ID : 0, 
                ordj_name: currentItem.ordj_name, 
                ordj_qty: currentItem.ordj_qty,
                products: selectedProducts.map((product) => ({
                    pto_ID: product.pto_ID,
                    qty: 1,
                    name: product.name,
                    price: product.price,
                    comment: null,
                    discount: product.discount || "0.0000"
                }))
            };
        }

        setFormData((prevFormData) => {
            let updatedItems = [...prevFormData.items];

            if (editMode) {

                updatedItems[editIndex] = newItem;
            } else {
                if (newItem.ordj_name === "Others") {
                    const existingOthersIndex = updatedItems.findIndex(item => item.ordj_name === "Others");
                    if (existingOthersIndex !== -1) {

                        updatedItems[existingOthersIndex] = newItem;
                    } else {

                        updatedItems.push(newItem);
                    }
                } else {

                    updatedItems.push(newItem);
                }
            }

            updatedItems = ensureOthersAtEnd(updatedItems);

            return { ...prevFormData, items: updatedItems };
        });
        //console.log("Unexpected error, please check")


        setSelectedProducts([]);

        setCurrentItem("");
        setEditMode(false);
        setEditIndex(null);
        closeModalItem(); 
    };

    const handleEditItem = (item, itemIndex) => {

        setCurrentItem(item);  
        setSelectedProducts(item.products);  
        setEditMode(true);
        setEditIndex(itemIndex); 
        showModalItem(); 
    };

    const handleDeleteItem = (itemIndex) => {
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to remove the job?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    items: prevFormData.items.filter((_, index) => index !== itemIndex)
                }));
                //Swal.fire("Item has been deleted!", { icon: "success" });

            }
        })

    };


    const handleQtyChange = (itemIndex, productIndex, newQty) => {
        setFormData((prevFormData) => {
            let updatedItems = [...prevFormData.items];
            updatedItems[itemIndex].products[productIndex].qty = newQty > 0 ? newQty : 1;
            return { ...prevFormData, items: updatedItems };
        });
    };

    const handleQtyItemChange = (itemIndex, newQty) => {
        setFormData((prevFormData) => {
            let updatedItems = [...prevFormData.items];
            updatedItems[itemIndex].ordj_qty = newQty > 0 ? newQty : 1;
            return { ...prevFormData, items: updatedItems };
        });
    };

    const handlePriceChange = (itemIndex, productIndex, newPrice) => {
        setFormData((prevFormData) => {
            let updatedItems = [...prevFormData.items];
            updatedItems[itemIndex].products[productIndex].price = newPrice > 0 ? newPrice : "";
            return { ...prevFormData, items: updatedItems };
        });
    };

    const handleDiscountChange = (itemIndex, productIndex, newDiscount) => {
        setFormData((prevFormData) => {
            let updatedItems = [...prevFormData.items];
            updatedItems[itemIndex].products[productIndex].discount = newDiscount >= 0 ? newDiscount : "";
            return { ...prevFormData, items: updatedItems };
        });
    };

    const handleItemChange = (itemIndex, field, value) => {
        setFormData((prevFormData) => {
            let updatedItems = [...prevFormData.items];
            updatedItems[itemIndex][field] = value;
            return { ...prevFormData, items: updatedItems };
        });
    };

    const calculateSubTotal = (items) => {
        return items.reduce((total, item) => {

            const qty = item.qty ? parseFloat(item.qty) : 0; 
            const price = item.price ? parseFloat(item.price) : 0; 
            const discount = item.discount ? parseFloat(item.discount) : 0; 

            let itemTotal = qty * price * (1 - (discount / 100));

            //console.log("Unexpected error, please check")


            return total + itemTotal;
        }, 0);
    };

    const calculateDiscountTotal = (items) => {
        return items.reduce((total, item) => {
            const discount = item.discount ? parseFloat(item.discount) : 0;


            return total + discount; 
        }, 0); 
    };

   
    const calculateTotalAmount = (subTotal, tax, discount) => {
        return subTotal + tax - discount;
    };


    const calculateTax = (subTotal) => {
        return subTotal * 0.20;
    };


    const transformItems = (items) => {
        let transformedItems = [];

        items.forEach(item => {
            const { job_ID, ordj_name, ordj_qty, ordj_price, ordj_description, ordj_discount, products } = item;

            if (ordj_name) {
                transformedItems.push({
                    id: formData.ord_ID ? formData.ord_ID : null,
                    ordj_id: job_ID,
                    pto_id: 0,
                    comment: ordj_name,  
                    descript: ordj_description || "",
                    qty: ordj_qty || 1,
                    price: parseFloat(ordj_price) || 0, 
                    discount: parseFloat(ordj_discount) || 0 
                });
            }

            if (Array.isArray(products) && products.length > 0) {
                products.forEach(product => {
                    transformedItems.push({
                        id: formData.ord_ID ? formData.ord_ID : 0,
                        ordj_id: job_ID || 0,
                        pto_id: product.pto_ID || 0,
                        comment: ordj_name,
                        descript: ordj_description || ordj_name, 
                        qty: product.qty || 0,  
                        price: parseFloat(product.price) || 0,  
                        discount: parseFloat(product.discount) || 0  
                    });
                });
            }
        });

        return transformedItems;
    };


    const reverseTransformItems = (transformedItems) => {
        let originalItems = [];

        let jobMap = {};

        transformedItems.forEach(item => {
            const { job_id, pto_id, product, descript, qty, price, discount } = item;

            if (!pto_id) {

                if (!jobMap[job_id]) {
                    jobMap[job_id] = {
                        ordj_ID: job_id,
                        ordj_name: product,
                        products: []
                    };
                }
            } else {

                if (!jobMap[job_id]) {
                    jobMap[job_id] = {
                        ordj_ID: job_id,
                        ordj_name: null, 
                        products: []
                    };
                }

                jobMap[job_id].products.push({
                    pto_ID: pto_id,
                    qty: qty,
                    price: price,
                    comment: null,  
                    discount: discount
                });
            }
        });

        for (let key in jobMap) {
            originalItems.push(jobMap[key]);
        }

        return originalItems;
    };

    useEffect(() => {
        //console.log("Unexpected error, please check")

        const updatedSummary = transformItems(formData.items);
        //console.log("Unexpected error, please check")

       
        setAmmountSummary(updatedSummary);
    }, [formData.items]);


    // Modification of insertinice

    const insertInvoice = async (e) => {
        e.preventDefault();
        setLoading(true);

        const transformedItems = transformItems(formData.items);


        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    //formData.items = transformedItems;

                    const response = await axios.post(`${server_backend}/invoices/insert`, {
                        name: formData.name || null,
                        lastname: formData.lastname || null,
                        email: formData.email || null,
                        phone: formData.phone || null,
                        phone2: formData.phone2 || null,
                        address: formData.address || null,
                        city: formData.city || null,
                        zipcode: formData.zipcode || null,
                        country: formData.country || null,
                        shipping_address: formData.shipping_address || null,
                        shipping_city: formData.shipping_city || null,
                        shipping_zipcode: formData.shipping_zipcode || null,
                        shipping_country: formData.shipping_country || null,
                        contact_fullname: formData.contact_fullname || null,
                        contact_phone: formData.contact_phone || null,
                        contact_email: formData.contact_email || null,
                        comment: formData.comment || null,
                        cust_id: formData.cust_ID || null,
                        ord_id: formData.ord_ID || null,
                        items: transformedItems
                    }, headers);

                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Created Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        navigate('/invoice-list')
                    }
                } catch (error) {
                    const responseData = error.response?.data?.RES_MESSAGE || "An error occurred";
                    //console.log("Unexpected error, please check")

                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const showModalCustomerViews = () => {
        setCustomerView(true);
    }

    const closeModalCustomerViews = () => {

        if (selectedCustomer) {
            setCustomerView(false);
        } else {
            Swal.fire({
                icon: 'error',
                title: "You must select a customer to proceed with generating the invoice.",
                showConfirmButton: false,
                timer: 2000
            });
        }

    }

    useEffect(() => {
        if (!editMode) {
            setCurrentItem((prevItem) => ({ ...prevItem, ordj_name: "Others" }));
        }
    }, [editMode]);


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="card-header">
                    <div className="d-flex justify-content-end mt-3 p-2">
                        <div className="flex-grow-1">
                            <div className="hstack text-nowrap gap-2">
                                <Link type="button" className="btn btn-danger" to="/invoice-list" data-bs-toggle="tooltip" data-bs-placement="top" title="Go Back"><i className="ri-arrow-go-back-line"></i></Link>
                            </div>
                        </div>

                        {/*   <div className="flex-shrink-0">
                            <div className="hstack text-nowrap gap-2">
                                <button className="btn btn-secondary" onClick={LoginXero}>
                                    Generate Token
                                </button>
                            </div>
                        </div>

                        <div className="flex-shrink-0">
                            <div className="hstack text-nowrap gap-2">
                                <button className="btn btn-danger" onClick={getTenantId}>
                                    Generate Tenai ID
                                </button>
                            </div>
                        </div>

                        <div className="flex-shrink-0">
                            <div className="hstack text-nowrap gap-2">
                                <button className="btn btn-success" onClick={CreateManualInvoiceXero}>
                                    Send invoice to Xero
                                </button>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div id="invoice-container">
                                <center>
                                    <h5 className="text-muted" style={{ paddingBlock: "5px" }}>INVOICE</h5>
                                </center>
                                <div className="card-header border-bottom-dashed p-4">
                                    <div className="d-sm-flex">
                                        <div className="flex-grow-1">
                                            <img src="assets/images/dbclondon-sm.jpg" alt="" height="60" />
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="mt-sm-5 mt-4">
                                                            <h6 className="text-muted text-uppercase fw-semibold">Address</h6>
                                                            <p className="text-muted mb-1" id="address-details">Design Build Cast Ltd
                                                                Unit 3.01,</p>
                                                            <p className="text-muted mb-0">The Goldsmiths Centre,</p>
                                                            <p className="text-muted mb-0">42 Britton Street,
                                                                London EC1M 5AD</p>
                                                            {/*  <div className="d-flex align-items-center justify-content-between  mt-2">
                                                                <h6 className="mb-0 text-muted fw-normal">Would you like to create the invoice based on an order?</h6>
                                                            </div> */}
                                                            {/*  <div className="d-flex align-items-center justify-content-start mt-2">

                                                                <button
                                                                    className={`btn btn-outline-success d-flex align-items-center me-2 px-3 py-1 ${selectedOption === 'yes' ? 'active' : ''}`}
                                                                    onClick={() => {
                                                                        showModalAttOrder();
                                                                    }
                                                                    }
                                                                    style={{ fontSize: '14px' }}
                                                                >
                                                                    <i className="ri-check-line me-1"></i>
                                                                    Yes
                                                                </button>


                                                                <button
                                                                    className={`btn btn-outline-danger d-flex align-items-center px-3 py-1 ${selectedOption === 'no' ? 'active' : ''}`}
                                                                    onClick={confirmNoOrderSelection}
                                                                    style={{ fontSize: '14px' }}
                                                                >
                                                                    <i className="ri-close-line me-1"></i>
                                                                    No
                                                                </button>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="mt-sm-5 mt-4">
                                                            <h6 className="text-muted text-uppercase fw-semibold">Review Information</h6>
                                                            {formData.user_close && (
                                                                <>
                                                                    <p className="text-muted mb-0 fs-25" >Reviewed by: {formData.user_close}</p>
                                                                    <p className="text-muted mb-1" id="address-details">{vAdminformat.FormatDate(formData.date_close)}</p>

                                                                    <p className="text-muted mb-0">{formData.comment_close}</p>
                                                                </>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex-shrink-0 mt-sm-0 mt-3">
                                            <h6><span className="text-muted fw-normal">Email:</span> <span id="email">enquiries@designbuildcast.co.uk</span></h6>
                                            <h6><span className="text-muted fw-normal">Website:</span> <a href="https://enquiries@designbuildcast.co.uk/" className="link-primary" target="_blank" id="website">designbuildcast.co.uk</a></h6>
                                            <h6 className="mb-0"><span className="text-muted fw-normal">Contact No: </span><span id="contact-no">0207 608 2228
                                            </span></h6>
                                        </div>
                                    </div>
                                </div>
                                {/*end card-header*/}
                                <div className="card-body p-4">
                                    <div className="row g-3">
                                        <div className="col-lg-3 col-sm-6">
                                            <label for="invoicenoInput">Order No</label>
                                            <p className="text-muted mb-0 fs-25" >{formData.ord_ID}</p>
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <div>
                                                <label for="date-field">Date</label>
                                                <p className="text-muted mb-0 fs-25" >{vAdminformat.FormatDate(formData.date_created)} </p>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <div>
                                                <label for="totalamountInput">Total Amount</label>
                                                <p className="text-muted mb-0 fs-25"> {/* {`${vAdminformat.FormatMoney(calculateSubTotal() +
                                                    calculateSubTotal() *0.20 -
                                                    (calculateSubTotal() *(formData.discount /100) || 0)
                                                )}`}  */}</p>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <label htmlFor="choices-payment-status">Payment Status</label>
                                            <div className="input-light">
                                                <select
                                                    className="form-control bg-light border-0"
                                                    id="choices-payment-status"
                                                    required
                                                    value={formData.est_id || formData.est_ID || ''}
                                                    onChange={(e) => setFormData({ ...formData, est_id: e.target.value })}
                                                >
                                                    <option value="">Select Payment Status</option>

                                                    {statusQuot.map((status) => (
                                                        <option key={status.est_ID} value={status.est_ID}>
                                                            {status.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                                <div className="card-body p-4 border-top border-top-dashed">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-lg-6 col-sm-6">

                                                <div className='mb-3'>
                                                    <label for="billingName" className="text-muted text-uppercase fw-semibold">Customer Information</label>
                                                </div>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>ID:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>{formData.cust_ID}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Name:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.name}
                                                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                                    /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Last Name:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.lastname}
                                                                        onChange={(e) => setFormData({ ...formData, lastname: e.target.value })}
                                                                    /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Email:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}><input type="text" className="form-control bg-light border-0"
                                                                    data-plugin="cleave-phone"
                                                                    value={formData.email}
                                                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                                                /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Phone 1:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.phone}
                                                                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Phone 2:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.phone2}
                                                                        onChange={(e) => setFormData({ ...formData, phone2: e.target.value })}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                )}


                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <div className='mb-3'>
                                                    <label for="shippingName" className="text-muted text-uppercase fw-semibold">Customer Address
                                                    </label>
                                                </div>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Address:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}><input type="text"
                                                                    className="form-control bg-light border-0"
                                                                    data-plugin="cleave-phone" id="billingPhoneno"

                                                                    value={formData.address}
                                                                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                                /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>City:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"

                                                                        value={formData.city}
                                                                        onChange={(e) => setFormData({ ...formData, city: e.target.value })} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Country:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"

                                                                        value={formData.country}
                                                                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                                                    /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Post Code:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"
                                                                        value={formData.zipcode}
                                                                        onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })} /></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*end card-body*/}
                                <div className="card-body p-4">
                                    <div className="table-responsive">
                                        <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                            <thead>
                                                <tr className="table-secondary">
                                                    <th scope="col">Item Name</th>
                                                    <th scope="col">Product Details</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col">Unit Price</th>
                                                    <th scope="col">Discount</th>
                                                    <th scope="col" className="text-end">Amount</th>
                                                    <th scope="col">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody id="products-list">
                                                {formData.items && formData.items.map((item, itemIndex) => (
                                                    <>
                                                        <tr key={itemIndex}>

                                                            <td>
                                                                <strong>
                                                                    {item.ordj_name}
                                                                </strong>
                                                            </td>

                                                            <td>
                                                                {item.ordj_description}
                                                            </td>

                                                            <td>
                                                                <td className="text-center d-flex justify-content-center">
                                                                    {item.ordj_qty && (
                                                                        <div className="input-group" style={{ width: "85%" }}>
                                                                            <button
                                                                                className="btn btn-outline-secondary"
                                                                                type="button"
                                                                                onClick={() => handleQtyItemChange(itemIndex, item.ordj_qty - 1)}
                                                                            >-</button>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center"
                                                                                value={item.ordj_qty}
                                                                                onChange={(e) => handleQtyItemChange(itemIndex, parseFloat(e.target.value))}
                                                                            />
                                                                            <button
                                                                                className="btn btn-outline-secondary"
                                                                                type="button"
                                                                                onClick={() => handleQtyItemChange(itemIndex, item.ordj_qty + 1)}
                                                                            >+</button>
                                                                        </div>
                                                                    )}

                                                                </td>
                                                            </td>
                                                            {/* Editable Unit Price */}
                                                            <td>
                                                                {item.ordj_qty && (
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={item.ordj_price}
                                                                        onChange={(e) => handleItemChange(itemIndex, 'ordj_price', parseFloat(e.target.value))}
                                                                    />
                                                                )}
                                                            </td>
                                                            {/* Editable Discount */}
                                                            <td>
                                                                {item.ordj_qty && (
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={item.ordj_discount}
                                                                        onChange={(e) => handleItemChange(itemIndex, 'ordj_discount', parseFloat(e.target.value))}
                                                                    />
                                                                )}
                                                            </td>
                                                            {/* Calculated Amount */}
                                                            <td className="text-end">
                                                                {item.ordj_qty && (
                                                                    <div>
                                                                        {vAdminformat.FormatMoney((item.ordj_qty * item.ordj_price) - item.ordj_discount)}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>

                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-primary me-2"
                                                                        onClick={() => handleEditItem(item, itemIndex)}
                                                                    >
                                                                        <i className="ri-edit-line"></i>
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-danger"
                                                                        onClick={() => handleDeleteItem(itemIndex)}
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </button>
                                                                </div>

                                                            </td>
                                                        </tr>
                                                        {item.products.map((product, productIndex) => (
                                                            <tr key={productIndex}>
                                                                <td></td>
                                                                <td>{product.name}</td>
                                                                <td className="text-center d-flex justify-content-center">
                                                                    <div className="input-group" style={{ width: "85%" }}>
                                                                        <button
                                                                            className="btn btn-outline-secondary"
                                                                            type="button"
                                                                            onClick={() => handleQtyChange(itemIndex, productIndex, product.qty - 1)}
                                                                        >-</button>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control text-center"
                                                                            value={product.qty}
                                                                            onChange={(e) => handleQtyChange(itemIndex, productIndex, parseFloat(e.target.value))}
                                                                        />
                                                                        <button
                                                                            className="btn btn-outline-secondary"
                                                                            type="button"
                                                                            onClick={() => handleQtyChange(itemIndex, productIndex, product.qty + 1)}
                                                                        >+</button>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={product.price}
                                                                        onChange={(e) => handlePriceChange(itemIndex, productIndex, parseFloat(e.target.value))}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={product.discount}
                                                                        onChange={(e) => handleDiscountChange(itemIndex, productIndex, parseFloat(e.target.value))}
                                                                    />
                                                                </td>
                                                                <td className="text-end">
                                                                    {vAdminformat.FormatMoney((product.qty * product.price) - product.discount)}
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                ))}
                                                <tr>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-soft-secondary fw-medium"
                                                            onClick={showModalItem}
                                                        >
                                                            <i className="ri-add-line align-bottom me-1"></i> Add Item
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr className="border-top border-top-dashed mt-2">
                                                    <td colSpan="5"></td>
                                                    <td colSpan="2" className="fw-medium p-0">
                                                        <table className="table table-borderless text-start table-nowrap align-middle mb-0">
                                                            <tbody>
                                                                <tr>
                                                                    <td>Sub Total</td>
                                                                    <td className="text-end">
                                                                        {vAdminformat.FormatMoney(calculateSubTotal(ammountSummary))}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Estimated Tax (20%)</td>
                                                                    <td className="text-end">
                                                                        {vAdminformat.FormatMoney(calculateTax(calculateSubTotal(ammountSummary)))}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Discount Total</td>
                                                                    <td className="text-end">
                                                                        -{vAdminformat.FormatMoney(calculateDiscountTotal(ammountSummary))}
                                                                    </td>
                                                                </tr>
                                                                <tr className="border-top border-top-dashed">
                                                                    <th scope="row">Total Amount</th>
                                                                    <td className="text-end">
                                                                        {vAdminformat.FormatMoney(calculateTotalAmount(
                                                                            calculateSubTotal(ammountSummary),
                                                                            calculateTax(calculateSubTotal(ammountSummary)),
                                                                            calculateDiscountTotal(ammountSummary)
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>


                                            </tbody>
                                        </table>

                                    </div> <div className="hstack gap-2 justify-content-end d-print-none mt-4">

                                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} to="/invoice-list">Discard Change</Link>

                                        <button type="submit" className="btn btn-primary" onClick={insertInvoice}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div
                className={`modal fade ${modalItem ? "show" : ""}`}
                style={{ display: modalItem ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addItemModalLabel">
                                {editMode ? "Edit Item" : "Add Item"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeModalItem}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 shadow">
                                            <div className="card-body">
                                                <center>
                                                    <h5 className="card-title mb-4">Item Name</h5>
                                                </center>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Product Name"
                                                    value={currentItem.ordj_name}
                                                    onChange={(e) => setCurrentItem({ ...currentItem, ordj_name: e.target.value })}
                                                    required
                                                    disabled={editMode}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 shadow">
                                            <div className="card-body">
                                                <center>
                                                    <h5 className="card-title mb-4">Products</h5>
                                                </center>
                                                <div className="table-responsive">
                                                    <table className="table table-hover align-middle">
                                                        <thead>
                                                            <tr>
                                                                <th>Select</th>
                                                                <th>ID</th>
                                                                <th>Name</th>
                                                                <th>Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {ProductList.map((product) => (
                                                                <tr
                                                                    key={product.pto_ID}
                                                                    onClick={() => handleCheckboxChange(product)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedProducts.some(
                                                                                (p) => p.pto_ID === product.pto_ID
                                                                            )}
                                                                            onChange={() => handleCheckboxChange(product)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        />
                                                                    </td>
                                                                    <td>{product.pto_ID}</td>
                                                                    <td>{product.name}</td>
                                                                    <td>{vAdminformat.FormatMoney(product.price)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                onClick={closeModalItem}
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSaveChanges}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`modal fade ${attachOrder ? "show" : ""}`}
                style={{ display: attachOrder ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <center>
                                <h5 className="modal-title" id="myExtraLargeModalLabel">Select Existing Order</h5>
                            </center>
                            <Link className="btn-close" to="/invoice-list" aria-label="Close"></Link>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div>
                                <div className="mb-3" ref={dropdownRef}>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="input-light">
                                                    <p className='p-0 m-0 text-muted'>Find by</p>
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"

                                                        value={filterBy}
                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option value="">Filter by</option>
                                                        <option value="ord_ID">Order ID</option>
                                                        <option value="fullname">Customer name</option>
                                                        <option value="email">Email</option>
                                                        <option value="phone">Phone</option>
                                                        <option value="city">City</option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <p className='p-0 m-0 text-muted'>Search For</p>
                                                <div className='mb-3'>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="select-existing-Order"
                                                        onKeyUp={handleFilterValueChange}
                                                        onFocus={() => setShowDropdown(true)}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        key="master"
                                        type='button'
                                        className={`d-flex text-start justify-content-between w-100 mb-2`}
                                        style={{
                                            padding: '10px 15px',
                                            borderRadius: '6px',
                                            border: '0px solid #dcdcdc',
                                        }}

                                    >
                                        <div className="col-1 text-center">

                                        </div>
                                        <div className="col-1">
                                            <span>ID</span>
                                        </div>

                                        <div className="col-md-3">
                                            <span>Full Name</span>
                                        </div>
                                        <div className="col-md-3">
                                            <span>Phone</span>
                                        </div>
                                        <div className="col-md-2">
                                            <span>Phone</span>
                                        </div>
                                    </button>
                                    <div className="mt-2" style={{ maxHeight: '250px', overflowY: 'auto', padding: "15px", border: '1px solid #dcdcdc', backgroundColor: '#fff' }}>
                                        {OrderList.length > 0 ? (
                                            OrderList.map((Order) => (
                                                <button
                                                    key={Order.ord_ID}
                                                    type='button'
                                                    className={`d-flex text-start justify-content-between w-100 mb-2 ${temporaryOrder === Order.ord_ID ? 'bg-primary text-white shadow-sm' : ''}`}
                                                    style={{
                                                        padding: '10px 15px',
                                                        borderRadius: '6px',
                                                        border: '0px solid #dcdcdc',
                                                        backgroundColor: temporaryOrder?.ord_ID === Order.ord_ID ? '#007bff' : '#fff',
                                                        color: temporaryOrder === Order.ord_ID ? '#fff' : '#333',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                                    }}
                                                    onClick={() => handleOrderSelect(Order.ord_ID)}
                                                >
                                                    <div className="col-1 text-center">
                                                        <input
                                                            type="radio"
                                                            name="selectedOrder"
                                                            checked={temporaryOrder === Order.ord_ID}
                                                            onChange={() => handleOrderSelect(Order)}
                                                        />
                                                    </div>
                                                    <div className="col-1">
                                                        <span>{Order.ord_ID}</span>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <span>{Order.fullname}</span>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <span>{Order.phone}</span>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <span>{Order.phone2}</span>
                                                    </div>
                                                </button>
                                            ))
                                        ) : (
                                            <div className="text-center">No Orders found</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end">
                                <Link type="button" className="btn btn-danger" style={{ marginRight: "5px" }} to="/invoice-list">
                                    Discard
                                </Link>
                                <button type="button" className="btn btn-primary" onClick={confirmOrderSelect}>
                                    Select
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div
                className={`modal fade ${customerViews ? "show" : ""}`}
                style={{ display: customerViews ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <center>
                                <h5 className="modal-title" id="myExtraLargeModalLabel">Select Existing Customer</h5>
                            </center>
                            <Link className="btn-close" to="/invoice-list" aria-label="Close"></Link>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div>
                                <div className="mb-3" ref={dropdownRef}>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="input-light">
                                                    <p className='p-0 m-0 text-muted'>Find by</p>
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"

                                                        value={filterBy}
                                                        onChange={handleCustFilterByChange}
                                                    >
                                                        <option value="">Filter by</option>
                                                        <option value="cust_ID">Customer ID</option>
                                                        <option value="fullname">Customer name</option>
                                                        <option value="email">Email</option>
                                                        <option value="phone">Phone</option>
                                                        <option value="city">City</option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <p className='p-0 m-0 text-muted'>Search For</p>
                                                <div className='mb-3'>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="select-existing-Order"
                                                        onKeyUp={handleCustFilterValueChange}
                                                        onFocus={() => setShowDropdown(true)}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        key="master"
                                        type='button'
                                        className={`d-flex text-start justify-content-between w-100 mb-2`}
                                        style={{
                                            padding: '10px 15px',
                                            borderRadius: '6px',
                                            border: '0px solid #dcdcdc',
                                        }}

                                    >
                                        <div className="col-1 text-center">

                                        </div>
                                        <div className="col-1">
                                            <span>ID</span>
                                        </div>

                                        <div className="col-md-3">
                                            <span>Full Name</span>
                                        </div>
                                        <div className="col-md-3">
                                            <span>Email</span>
                                        </div>
                                        <div className="col-md-2">
                                            <span>Phone</span>
                                        </div>
                                    </button>
                                    <div className="mt-2" style={{ maxHeight: '250px', overflowY: 'auto', padding: "15px", border: '1px solid #dcdcdc', backgroundColor: '#fff' }}>
                                        {CustomerList.length > 0 ? (
                                            CustomerList.map((customer) => (
                                                <button
                                                    key={customer.cust_ID}
                                                    type='button'
                                                    className={`d-flex text-start justify-content-between w-100 mb-2 ${selectedCustomer === customer.cust_ID ? 'bg-primary text-white shadow-sm' : ''}`}
                                                    style={{
                                                        padding: '10px 15px',
                                                        borderRadius: '6px',
                                                        border: '0px solid #dcdcdc',
                                                        backgroundColor: selectedCustomer?.cust_ID === customer.cust_ID ? '#007bff' : '#fff',
                                                        color: selectedCustomer === customer.cust_ID ? '#fff' : '#333',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                                    }}
                                                    onClick={() => handleCustomerSelect(customer.cust_ID)}
                                                >
                                                    <div className="col-1 text-center">
                                                        <input
                                                            type="radio"
                                                            name="selectedOrder"
                                                            checked={selectedCustomer === customer.cust_ID}
                                                            onChange={() => handleCustomerSelect(customer)}
                                                        />
                                                    </div>
                                                    <div className="col-1">
                                                        <span>{customer.cust_ID}</span>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <span>{customer.fullname}</span>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <span>{customer.phone}</span>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <span>{customer.phone2}</span>
                                                    </div>
                                                </button>
                                            ))
                                        ) : (
                                            <div className="text-center">No Customer found</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end">
                                <Link type="button" className="btn btn-danger" style={{ marginRight: "5px" }} to="/invoice-list">
                                    Discard
                                </Link>
                                <button type="button" className="btn btn-primary" onClick={confirmCustomer}>
                                    Select
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}


export default ManualInvoiceCreate;